const workshopAssetKey = (value) => {
  if (value == null || value === "") return null;
  return String(value);
};

export const isSameWorkshopAssetId = (left, right) => {
  const leftKey = workshopAssetKey(left);
  const rightKey = workshopAssetKey(right);
  return leftKey != null && leftKey === rightKey;
};

/**
 * Merge a saved workshop entity into the visible list immediately.
 * IDs are normalized because older endpoints may mix numeric and string IDs.
 */
export const mergeWorkshopAssetById = (items, savedAsset) => {
  const currentItems = Array.isArray(items) ? items : [];
  const savedKey = workshopAssetKey(savedAsset?.id);
  if (!savedKey) return currentItems;

  let matched = false;
  const merged = currentItems.map((item) => {
    if (!isSameWorkshopAssetId(item?.id, savedKey)) return item;
    matched = true;
    // Keep the ID representation already used by the visible list. Selection
    // state compares IDs strictly, while legacy endpoints may return the same
    // ID once as a number and once as a string.
    return { ...item, ...savedAsset, id: item.id };
  });

  return matched ? merged : [...merged, savedAsset];
};

export const nextWorkshopListRequestSequence = (currentSequence) => {
  const normalized = Number.isSafeInteger(currentSequence) && currentSequence >= 0
    ? currentSequence
    : 0;
  return normalized + 1;
};

export const isLatestWorkshopListRequest = (requestSequence, latestSequence) =>
  requestSequence === latestSequence;
